export enum StepState {
  Previous = 'previous',
  Current = 'current',
  Next = 'next',
}
